import type { TTranslationKeys } from "$/i18n/i18n"

import { THEME } from "@/3514/theme"
import { seconds } from "@/3514/utils/time.utils"

const pageBlocksTitlesMap: { [B in "summary" | "individuals"]: keyof TTranslationKeys } = {
    summary: "coachSide.groupPage.summary.title",
    individuals: "coachSide.groupPage.individuals.title"
}

const summaryRichTextCssIdentifier: string = "cgsdc-e"

function getSummaryRichTextClasses(
    identifier: string,
    { isTextSmall = false }: { isTextSmall?: boolean } = { isTextSmall: false }
): string {
    return `
        .${identifier} * { 
          color: ${THEME.COLORS.gray[100]};
          font-weight: ${THEME.FONT_WEIGHTS[300]};
          line-height: ${isTextSmall ? THEME.LINE_HEIGHTS[21] : THEME.LINE_HEIGHTS[24]}px;
          font-size: ${isTextSmall ? THEME.FONT_SIZES[14] : THEME.FONT_SIZES[16]}px;
          white-space: pre-line;
        }
        .${identifier} strong { font-weight: ${THEME.FONT_WEIGHTS[800]}; }
        .${identifier} p, 
        .${identifier} ul { margin-bottom: 0px; }
        .${identifier} ul { list-style-position: inside; list-style-type: disc; padding-left: 5px; }
    `
}

const SUMMARY_MAX_REFETCH_COUNT: number = 10 - 1 // first success query doesnt populate dataUpdatedAt field

const SUMMARY_REFETCH_INTERVAL_IN_MS: number = seconds(7)
const SUMMARY_LOADING_ARTIFICIAL_DELAY_IN_MS: number = seconds(2)
const INDIVIDUAL_LOADING_ARTIFICIAL_DELAY_IN_MS: number = seconds(1.5)

export default {
    pageBlocksTitlesMap,
    SUMMARY_MAX_REFETCH_COUNT,
    SUMMARY_REFETCH_INTERVAL_IN_MS,
    SUMMARY_LOADING_ARTIFICIAL_DELAY_IN_MS,
    INDIVIDUAL_LOADING_ARTIFICIAL_DELAY_IN_MS,
    summaryRichTextCssIdentifier,
    getSummaryRichTextClasses
}
